<form [formGroup]="formGroup" class="barthel">
  @if (pageTitle) {
    <div class="barthel-page-header">
      <b>{{ getQuestionTitle(pageTitle) }}</b>
      @if (getQuestionInstruction(pageTitle)) {
        <div class="barthel-instruction">
          {{ getQuestionInstruction(pageTitle) }}
        </div>
      }
    </div>
  }
  @for (element of elements; track element.name) {
    @if (element.type === "radiogroup") {
      <div class="barthel-row">
        <div class="barthel-q">
          <div class="barthel-q-title">
            <span>{{ getQuestionTitle(element.title) }}</span>
          </div>
          @if (getQuestionInstruction(element.title)) {
            <div class="barthel-instruction">
              {{ getQuestionInstruction(element.title) }}
            </div>
          }
        </div>

        <div class="barthel-group">
          @for (choice of element.choices; track choice.value) {
            <label class="barthel-option">
              <input
                type="radio"
                [formControlName]="element.name"
                [value]="choice.value"
                (click)="onRadioClick(element.name, choice.value)"
              />
              <span class="barthel-option-text">{{
                choice.text
              }}</span>
            </label>
          }
        </div>
      </div>
    }
    @if (isTotalScoreElement(element)) {
      <div class="barthel-total">
        <div class="barthel-total-title">
          {{ getQuestionTitle(element.title) }}
        </div>
        <div class="barthel-total-score">
          {{ totalScore }} / {{ maxScore }}
        </div>
      </div>
    }
  }
</form>
